const fallbackMessage = "Unable to remove complimentary. Please try again.";
const responseLayers = (response) => [response?.data, response?.data?.data, response?.data?.data?.data].filter(Boolean);
const isFailure = (value) => Number(value?.es) > 0 || value?.success === false ||
  Number(value?.statusCode) >= 400 || ["ERROR", "FAILED", "FAILURE"].includes(String(value?.status || "").toUpperCase());

export const getRevertedComplimentaryCart = (response, cartId, cartProductId) => {
  const layers = responseLayers(response);
  const failure = layers.find(isFailure);
  if (failure || Number(response?.status) >= 400) {
    throw new Error(typeof failure?.message === "string" ? failure.message : fallbackMessage);
  }
  const cart = layers.find((value) => Array.isArray(value?.cartProducts));
  const product = cart?.cartProducts?.find((item) => String(item?.cartProductId) === String(cartProductId));
  if (!cart || String(cart?.cartId) !== String(cartId) || !product?.inventoryStatus ||
    String(product?.inventoryStatus).toUpperCase() === "COMPLEMENTARY" ||
    cart?.billing?.totalCartValue == null || !Number.isFinite(Number(cart?.billing?.totalCartValue))) {
    throw new Error("Could not confirm the complimentary removal. Please refresh the cart before retrying.");
  }
  return cart;
};

export const getComplimentaryRevertError = (error) => {
  const layers = responseLayers(error?.response);
  const message = [...layers].reverse().find((value) => typeof value?.message === "string")?.message;
  return message || error?.message || fallbackMessage;
};
